module.exports = __webpack_public_path__ + "static/img/game1.a5a57b33.png";